export default {"src":"/_next/static/media/manta-explorer.ba587176.svg","height":874,"width":874,"blurWidth":0,"blurHeight":0};